module.exports = __webpack_public_path__ + "assets/img/plan4-3.7174f04d.png";